import React, { useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import SideBar from "../../components/Sidebar/index";
import { Card, Breadcrumb, Form, Input, Select, Button } from "antd";
import { queenApiCalling } from "../../constant/API";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import { SyncLoader } from "react-spinners";
import "../../css/main.css";

export default function CreateAdmin() {
  const formRef = React.useRef(null);
  const [accountType, setAccountType] = useState([
    {
      value: "Super Administrator",
      label: "Super Administrator",
    },
    {
      value: "Administrator",
      label: "Administrator",
    },
    {
      value: "Account Administrator",
      label: "Account Administrator",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = (v) => {
    setIsLoading(true);
    const params = {
      fullname: v.fullname,
      phoneNumber: v.phoneNumber,
      emailAddress: v.emailAddress,
      password: v.password,
      location: v.location,
      role: v.role,
      action: "CREATE_ADMIN",
    };
    queenApiCalling(params).then((res) => {
      setIsLoading(false);
      if (res.status === "success") {
        formRef.current?.resetFields();
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    });
  };

  return (
    <Box>
      <Grid>
        <></>
      </Grid>
      <Box md={{ width: "100%" }} style={{ marginTop: "0px" }}>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <Grid item md={2}>
            <SideBar type={localStorage.getItem("adminSession").role} />
          </Grid>
          <Grid
            md={10}
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{ flexDirection: { xs: "column", md: "row" } }}
            style={{ marginTop: "0px" }}
          >
            <Card
              title="Create Admin"
              style={{
                width: "98%",
                marginLeft: "1%",
                marginTop: "30px",
              }}
              extra={
                <Breadcrumb
                  items={[
                    {
                      href: "/dashboard",
                      title: <HomeOutlined />,
                    },
                    {
                      href: "/admin",
                      title: (
                        <>
                          <UserOutlined />
                          <span>Admin List</span>
                        </>
                      ),
                    },
                    {
                      title: "Create Admin",
                    },
                  ]}
                />
              }
            >
              <Card style={{ width: "50%" }}>
                <Form
                  ref={formRef}
                  layout="vertical"
                  name={"complex-form"}
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 24,
                  }}
                  style={{ width: "100%" }}
                  onFinish={onFinish}
                  autoComplete="off"
                >
                  <Form.Item
                    name="fullname"
                    label="Full name"
                    rules={[
                      { required: true, message: "full name is required" },
                    ]}
                  >
                    <Input placeholder={"Please enter full name"} />
                  </Form.Item>
                  <Form.Item
                    name="phoneNumber"
                    label="Phone Number"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={"Please enter phone number"} />
                  </Form.Item>
                  <Form.Item
                    name="emailAddress"
                    label="Email Address"
                    rules={[{ required: true }]}
                    autoComplete={false}
                  >
                    <Input placeholder={"Please enter email address"} />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[{ required: true }]}
                  >
                    <Input
                      placeholder={"Please enter password"}
                      type={"password"}
                    />
                  </Form.Item>
                  <Form.Item
                    name="location"
                    label="Location"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={"Please enter location"} />
                  </Form.Item>
                  <Form.Item
                    name="role"
                    label="Role"
                    rules={[{ required: true }]}
                  >
                    <Select options={accountType}></Select>
                  </Form.Item>

                  <Form.Item>
                    {isLoading ? (
                      <SyncLoader
                        color={"008080"}
                        loading={isLoading}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ background: "#008080", width: "100%" }}
                      >
                        Create Admin
                      </Button>
                    )}
                  </Form.Item>
                </Form>
              </Card>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <ToastContainer />
    </Box>
  );
}
